import { memo, useState, useCallback } from 'react';
import { Howler } from 'howler';
import OutlineText from './OutlineText';
import mutedIcon from "images/Host/lobby_muted.png";
import unmutedIcon from "images/Host/lobby_unmuted.png";
import fullscreenIcon from "images/Host/lobby_fullscreen.png";
import helpIcon from "images/Host/lobby_help.png";
import QRCode from 'qrcode.react';

const RoomDetails = memo(function RoomDetails({ styles, url, displayUrl, muted, roomId, fullscreenAvailable, onToggleMute, onToggleFullScreen, onToggleMenu, hideButtons, isMirror }) {
    // Local mute state for mirrors (doesn't affect primary host's audio)
    const [localMuted, setLocalMuted] = useState(false);

    const handleMuteClick = useCallback(() => {
        if (isMirror) {
            const newMuted = !localMuted;
            Howler.mute(newMuted);
            setLocalMuted(newMuted);
        } else {
            onToggleMute();
        }
    }, [isMirror, localMuted, onToggleMute]);

    const isMuted = isMirror ? localMuted : muted;

    return (
        <div className={styles.roomCode}>
            <div className={styles.textBox}>
                <OutlineText styles={styles} text={displayUrl} />
                <OutlineText styles={styles} text={(<>Code: <span className={`${styles.code}`}>{roomId}</span></>)} />

                {
                    isMirror &&
                    <div className={styles.mirrorBadge}>MIRROR</div>
                }

                {
                    !hideButtons &&
                    <div className={styles.iconsBox}>
                        <div className={styles.muteToggle} onClick={handleMuteClick}>
                            <img src={isMuted ? mutedIcon : unmutedIcon} className={styles.muteIcon} alt="mute" />
                        </div>
                        {
                            fullscreenAvailable ?
                                <div className={styles.muteToggle} onClick={() => onToggleFullScreen()}>
                                    <img src={fullscreenIcon} className={styles.muteIcon} alt="fullscreen" />
                                </div>
                                :
                                null
                        }
                        {
                            !isMirror &&
                            <div className={styles.muteToggle} onClick={() => onToggleMenu()}>
                                <img src={helpIcon} className={styles.muteIcon} alt="help" />
                            </div>
                        }
                    </div>
                }
            </div>
            <div className={styles.qrCodeBox}>
                <QRCode
                    className={styles.qrCode}
                    value={`${url}/play/?qrCode=${roomId}`}
                    bgColor="rgba(0,0,0,0)"
                />
            </div>
        </div>
    )
});

export default RoomDetails;